import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from '@angular/router';
import { FormChangedGuard } from './form-changed-guard/form-changed-guard';
import { AppearancePageComponent } from '../pages/cms/appearance-page/appearance-page.component';

@Injectable({
  providedIn: 'root',
})
export class AppearancePageGuard
  extends FormChangedGuard
  implements CanDeactivate<AppearancePageComponent>
{
  canDeactivate(
    component: AppearancePageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.handleNavigation(component.hasUnsavedChanges(), nextState.url);
  }
}
